import { Component, Output, OnInit, Input, ViewEncapsulation, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CheckboxComponent implements OnInit {
  @Input() name: string;
  @Input() disabled: boolean;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<boolean>();
  @Output() saveModel = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onChange(): void {
    this.valueChange.emit(this.value);
  }

  onSaveModel(): void {
    this.valueChange.emit(this.value);
    this.saveModel.emit();
  }
}
